export default "__VITE_ASSET__5788514d__"